import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { cssTransition, toast } from 'react-toastify/esm/react-toastify';
import ValidationMessages from './ValidationMessages';

//TODO: turn this info hook for useToastNofitications, toast notifications needs to be an app config prop -JJames

const toastNotification = ({
  id,
  message,
  enter='fadeIn',
  exit='fadeOut',
  duration=[500, 0],
  appendPosition=false,
  autoClose=10000,
  className='ignite-notification',
  draggable=false,
  ...rest
}) => {
  toast.dismiss(id);
  const transition = cssTransition({
    enter,
    exit,
    duration,
    appendPosition,
  });
  toast(message, {
    autoClose,
    className,
    draggable,
    toastId: id,
    transition,
    ...rest,
  });
};

const notifyValidationErrors = ({ id = 'validationErrors', validationErrors = [], autoClose = 10000 } ) => {
  const message = (
    <NotificationMessage
      title={<FormattedMessage id={`${id}.error.title`} />}
      message={<ValidationMessages validationErrors={validationErrors} />}
    />
  );

  toastNotification({
    id,
    message,
    type: toast.TYPE.ERROR,
    autoClose
  });
};

const notifySuccess = (id, config={}) => {
  const message = (
    <NotificationMessage
      title={<FormattedMessage id={`${id}.success.title`} />}
      message={<FormattedMessage id={`${id}.success.message`} />}
    />
  );
  toastNotification({ id, message, type: toast.TYPE.SUCCESS, ...config });
};

const notifyInfo = (id, config={}) => {
  const message = (
    <NotificationMessage
      title={<FormattedMessage id={`${id}.info.title`} />}
      message={<FormattedMessage id={`${id}.info.message`} />}
    />
  );
  toastNotification({ id, message, type: toast.TYPE.INFO, ...config });
};

const notifyWarning = (id, config={}) => {
  const message = (
    <NotificationMessage
      title={<FormattedMessage id={`${id}.warning.title`} />}
      message={<FormattedMessage id={`${id}.warning.message`} />}
    />
  );
  toastNotification({ id, message, type: toast.TYPE.WARNING, ...config });
};

const notifyError = (id, config={}) => {
  const message = (
    <NotificationMessage
      title={<FormattedMessage id={`${id}.error.title`} />}
      message={<FormattedMessage id={`${id}.error.message`} />}
    />
  );
  toastNotification({ id, message, type: toast.TYPE.ERROR, ...config });
};

const clearNotifications = () => {
  toast.dismiss();
};

const NotificationMessage = ({
  className,
  icon,
  message,
  renderAfter,
  renderBefore,
  title,
}) => {
  const cssBEM = 'notificationMessages';
  const listOfMessages = Array.isArray(message) ? message : [message];
  const messages = listOfMessages.map((m, index) => (
    <div key={index} className={`${cssBEM}__message`}>
      {m}
    </div>
  ));
  return (
    <div className={`${cssBEM} ${className}`}>
      {title ? (
        <h4 className={`${cssBEM}__title`}>
          {icon}
          {title}
        </h4>
      ) : null}
      {renderBefore ? renderBefore : null}
      {messages}
      {renderAfter ? renderAfter : null}
    </div>
  );
};
NotificationMessage.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.element,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
  renderAfter: PropTypes.element,
  renderBefore: PropTypes.element,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export {
  toastNotification as default,
  clearNotifications,
  notifyInfo,
  notifyWarning,
  notifyError,
  notifySuccess,
  notifyValidationErrors,
  NotificationMessage,
};
